
import CopyToClipboardText from "@/components/base/input/CopyToClipboardText"
import { mapGetters } from "vuex"

export default {
    name: "BulletinBoardUnlockCard",
    components: { CopyToClipboardText },
    methods: {
        onEmblemFileClick() {},
        onEmblemStickerClick() {},
        onIntersect(e) {
            if (e[0].isIntersecting) {
                const video = this.$refs.backgroundVideo
                video.currentTime = 0
                video.play()
            }
        },
    },
    computed: {
        ...mapGetters("school", [
            "traineeInvitationLink",
            "traineeInvitationQrCode",
        ]),
        inviteURL() {
            return this.$config.baseURL + this.traineeInvitationLink
        },
        qrCode() {
            return "/storage/" + this.traineeInvitationQrCode.file_path
        },
    },
}
